import React from 'react';
import { HiArrowLeft } from "react-icons/hi";
import Skeleton from "../../../../shared/molecules/Skeleton/Skeleton";
import "./StrategyMapViewSubHeader.css";

export function StrategyMapViewSubHeaderSkeleton() {
    return (
      <div className="smv-sub-header relative">
        {/* Left section: Navigation, Status and Title */}
        <div className="smv-sub-header-left">
          <div className="smv-sub-header-back-btn">
            <HiArrowLeft className="text-xl text-light-text-secondary dark:text-gray-300 opacity-50" />
          </div>

          <div className="smv-sub-header-title-container">
            <Skeleton
              width={80}
              height={24}
              className="rounded-lg flex-shrink-0"
            />
            <Skeleton
              width={160}
              height={24}
              className="rounded-lg"
            />
          </div>
        </div>

        {/* Right section: Key Performance Indicators (KPIs) and Metrics */}
        <div className="smv-sub-header-right items-center">
          {/* Overall project progress visualization */}
          <div className="smv-sub-header-item smv-sub-header-stat">
            <div className="smv-sub-header-stat-header">
              <span className="smv-sub-header-stat-label">
                Overall Progress
              </span>
            </div>
            <div className="smv-sub-header-progress-container h-[20px] mt-1">
               <Skeleton width="100%" height="100%" className="rounded-full" />
            </div>
          </div>

          {/* Financial overview */}
          <div className="smv-sub-header-item smv-sub-header-stat">
            <span className="smv-sub-header-stat-label">Cost</span>
            <Skeleton width={60} height={20} className="rounded mt-1" />
          </div>

          {/* Composition/Content counts */}
          <div className="smv-sub-header-stat smv-sub-header-item">
            <span className="smv-sub-header-stat-label">
              Total Work Items
            </span>
            <Skeleton width={48} height={20} className="rounded mt-1" />
          </div>

          {/* Team involvement and resource allocation avatars */}
          <div className="smv-sub-header-item smv-sub-header-members">
            <span className="smv-sub-header-members-label">Members</span>
            <div className="flex -space-x-2 pl-2 mt-1">
              {[1, 2, 3].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="circular"
                  width={28}
                  height={28}
                  className="border-2 border-light-surfacePrimary dark:border-secondary-dark"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
}